export const PAPER_PROPS = {
  style: {
    padding: '16px',
    maxHeight: '90vh',
    display: 'flex',
    flexDirection: 'column' as const
  }
} as const

export const QR_CODE_SIZE = 200
